import React, { useState } from 'react';
import { Paper, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { customTheme } from '../customTheme';
// import { vehicleSvgs } from "../sharedData";
import Skeleton from '@material-ui/lab/Skeleton';
// import Chart from "react-apexcharts";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReactApexChart from 'react-apexcharts';

const useStyles = makeStyles({
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.grey[900],
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center"
    },
    summaryVehicleIcon: {
        width: 18,
        height: 18,
    },
    summaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 13,
        color: customTheme.palette.grey[900],
    },
    tooltip: {
        fontSize: 13
    }
});

const donutColor = ['#f59738', '#f54538']

export default function NewSummaryCard({ data, loading }) {
    const classes = useStyles();
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [selectedSummary, setSelectedSummary] = useState(data[selectedIndex])
    // const { value, distributedValues, distributedLabels, distributedIcons, distributedValueDescription, distributionCount, amount } = selectedSummary

    const summaryHandler = (val, index) => {
        setSelectedIndex(index)
        setSelectedSummary(val)
    }

    return (
        <Paper style={{ boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px", marginTop: 20, width: "70%" }}>
        <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        {
                data.map((val, i) => (
                    <div onClick={() => summaryHandler(val, i)} style={{  padding: "2px 15px", borderRadius: 5, backgroundColor: i === selectedIndex ? '#334D6E' : '#F5F8FA', color: i === selectedIndex ? '#F5F8FA' : '#334D6E', marginRight:10 }}>
                        <p style={{fontSize:12, lineHeight: 0}}>{val.title}</p>
                    </div>
                ))
            }
        </div>

            <div style={{ display: 'flex', marginTop: 20 }}>
                <div style={{width: '400px'}}>
                <div style={{ display: "grid", gridTemplateColumns: "100%" }}>
                    <div>
                        {
                            !loading ?
                                <div style={{ display: "flex" }}>
                                    <Typography className={classes.mainValue}>{selectedSummary.valueFormatter(selectedSummary.value)}</Typography>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                    {selectedSummary.valueDescription && <div style={{ fontSize: 14, margin: "5px" }}>{selectedSummary.valueDescription}</div>}
                                    {selectedSummary.valueDescriptionTooltip && <Tooltip arrow title={selectedSummary.valueDescriptionTooltip} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 16, color: "#888" }} /></Tooltip>}
                                </div>
                                </div>
                                :
                                <Skeleton variant="text" height={36} width="34%" />
                        }
                        {/* <Typography className={classes.title}>{selectedSummary.title}</Typography> */}
                    </div>

                    {/* {amount && <div>
                    <Typography className={classes.summaryBoxLabel2}>Amount</Typography>
                    {!loading ? <Typography className={classes.summaryBoxValue2}>{amount}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>} */}
                </div>
                <div className={classes.twoColumnGrid} style={{ gridRowGap: 3, padding: "5px 0px 5px" }}>
                {
                    !loading ? selectedSummary.distributedLabels.map((dL, i) => (
                        <div key={dL} className={classes.flexContainer}>
                            <img className={classes.summaryVehicleIcon} src={selectedSummary.distributedIcons[i]} alt={dL} />
                            <Typography className={classes.summaryBoxLabel1} style={{ marginRight: 16, color: donutColor[i] }}>{dL}:</Typography>
                            <Typography className={classes.summaryBoxValue1}>{selectedSummary.valueFormatter(selectedSummary.distributedValues[i])}</Typography>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {selectedSummary.distributedValueDescription && <div style={{ fontSize: 12, margin: "0 5px" }}>{selectedSummary.distributedValueDescription[i]}</div>}
                            </div>
                        </div>
                    )) :
                        [ "50%", "40%", "50%"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={22} key={index} />
                        ))
                }
                 {
                    !loading ? selectedSummary.distributedLabels.map((dL, i) => (
                        <div key={dL} className={classes.flexContainer}>
                            <img className={classes.summaryVehicleIcon} src={selectedSummary.distributedIcons[i]} alt={dL} />
                            <Typography className={classes.summaryBoxLabel1} style={{ marginRight: 16, color: donutColor[i] }}>{dL}:</Typography>
                            <Typography className={classes.summaryBoxValue1}>{selectedSummary.valueFormatter(selectedSummary.distributedValues[i])}</Typography>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {selectedSummary.distributedValueDescription && <div style={{ fontSize: 12, margin: "0 5px" }}>{selectedSummary.distributedValueDescription[i]}</div>}
                            </div>
                        </div>
                    )) :
                        [ "50%", "40%", "50%"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={22} key={index} />
                        ))
                }
            </div>
                </div>

                <ReactApexChart
                    series={selectedSummary.distributedValues}
                    type="donut" width={300}
                    options={{
                        labels: selectedSummary.distributedLabels,
                        colors: donutColor,
                        chart: {
                            width: 380,
                            type: 'donut',
                          },
                          dataLabels: {
                            enabled: false
                          },
                        plotOptions: {
                          pie: {
                            startAngle: -90,
                            endAngle: 90,
                            offsetY: 10
                          }
                        },
                        grid: {
                          padding: {
                            bottom: -80
                          }
                        },
                        legend: {
                            show:false
                        },
                        responsive: [{
                          breakpoint: 480,
                          options: {
                            chart: {
                              width: 200
                            },
                            legend: {
                              position: 'bottom'
                            }
                          }
                        }]
                      }}
                />

                {/* <ReactApexChart
                series={selectedSummary.distributedValues}
                type="pie"
                options={{
                    labels: selectedSummary.distributedLabels,
                    chart: {
                        type: "pie",
                        fontFamily: "Poppins-Regular",
                        height: 300,
                        width: 300
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    plotOptions: {
                        pie: {
                            size: 2,
                            expandOnClick: false,
                            donut: {
                                size: "75%",
                                labels: {
                                    show: false,
                                    total: {
                                        show: true,
                                        showAlways: false,
                                        color: "#777",
                                        fontSize: 10,
                                    },
                                    value: {
                                        show: true,
                                        fontSize: 17,
                                        offsetY: -7
                                    }
                                },
                            }
                        }
                    },
                    tooltip: {
                        
                    },
                    noData: {
                        text: loading ? "Loading..." : "No Data Yet",
                        offsetY: -18,
                        style: {
                            fontSize: 16
                        }
                    },
                    legend: {
                        show: true,
                        horizontalAlign: "left", 
                        position: "left",
                        offsetY: -20,
                        offsetX: -30,
                        fontSize: 12,
                        customLegendItems: selectedSummary.distributedLabels.map((v, i) => `${selectedSummary.distributedLabels[i]}: ${selectedSummary.distributedValues[i]} ${selectedSummary.distributedValueDescription ? selectedSummary.distributedValueDescription[i] : ""}`),
                        labels: {
                            colors: "#444"
                        },
                        markers: {
                            width: 10,
                            height: 10,
                            offsetX: -2,
                        }
                    }
                }}
            />  */}
            </div>
        </Paper>
    );
}